import { Component, OnInit, ViewChild } from '@angular/core';
import { Http, Response } from "@angular/http";
import { ScriptLoaderService } from '../_services/script-loader.service';
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { appService } from "../../app/_services/app.service";
import { Helpers } from "../helpers";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { PrintFormatsComponent } from "../print-formats/print-formats.component";
import { interval } from 'rxjs/observable/interval';
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;
declare var google: any;

@Component({
  selector: 'app-LiveTracking',
  templateUrl: './LiveTracking.component.html',
  styleUrls: ['./LiveTracking.component.scss']
})
export class LiveTrackingComponent implements OnInit {
  selectedLang: string;
  static liveTrackingComponent: LiveTrackingComponent;
  map: any;
  beachMarker: any;
  bookingId: any;
  consignmentDetailId: any;
  liveTrackData: any = { orderDetailsList: [{ starRating: '' }] };
  hostURL = environment.apiUrl;
  apiUrl = environment.apiUrl;
  hostUrl = environment.apiUrl;

  // hostUrl: any = 'https://kusshal.ifreightbox.net/'
  // hostURL: any = 'https://kusshal.ifreightbox.net/'

  rate: any = 0;
  feedbackRemark: any = '';
  ProductHeader: any = [];
  ProductData: any = [];
  ConsignmentsData: any = [];
  ConsignmentNote_3 = [1, 2, 3, 4];
  isHotShotshostUrl: any = environment.apiUrl == 'https://nol.ifreightbox.net/' ? true : false;

  //add vithujan 18-07-2022
  TenantUsers: any;
  BookingId: any;
  CompanyIdForCookie: any;
  imgPath: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any
  SelectedCompantEmail: any;
  SelectedCompanyWebsite: any;
  SelectedCompanyHeadAdd: any;
  CompanyWebsite: any;
  CompanyId: any;
  //end

  yardAddress: any = '';
  isGPS: boolean = false;
  GPSUrl: any = '';
  whitelabelFlag: boolean = false;
  LiveTrackingThrowWarehouseLatLongFlage: any = false;
  HideShowOrderRistInsuarnceGSTFreightFlag: any = false;
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;

  ConsignmentNote_2 = [1, 2, 3];
  ShowShipperConsigneeBasedOnTransportService: boolean = false;

  constructor(
    private service: TranslateConfigService,
    private _script: ScriptLoaderService,
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private http: Http,
    private translate: TranslateService) {
    LiveTrackingComponent.liveTrackingComponent = this;

    setInterval(function () {
      if (LiveTrackingComponent.liveTrackingComponent.isGPS == false) {
        LiveTrackingComponent.liveTrackingComponent.getDriverCurrentLatLong();
      }
    }, 5000);

    let intervalTime = LiveTrackingComponent.liveTrackingComponent.apiUrl == 'https://tt.ifreightbox.net/' ? 120000 : 5000; // Adjust time dynamically
    setInterval(function () {
      if (LiveTrackingComponent.liveTrackingComponent.isGPS == true) {
        LiveTrackingComponent.liveTrackingComponent.getDriverCurrentLatLong_GPS();
      }
    }, intervalTime);

    if (this.hostURL == 'https://nol.ifreightbox.net/') {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
    else {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  ngOnInit() {
    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js"
        ],
        true
      )
      .then(() => {
        document.getElementById("defaultOpen").click();
        this.GetLiveTrackingThrowWarehouseLatLongSettingVal();
        this._activatedRoute.params.subscribe((params: Params) => {
          this.bookingId = this._activatedRoute.snapshot.queryParams["bookingId"];
          this.consignmentDetailId = this._activatedRoute.snapshot.queryParams["consignmentDetailId"];
          // if (this.bookingId !== undefined && this.bookingId !== null && this.consignmentDetailId !== undefined && this.consignmentDetailId !== null) {
          setTimeout(() => {
            this.GetLiveTrackListForBookingFromURL();
          }, 500);
          // }
        });
      });

    //add vithujan 18-07-2022
    this._activatedRoute.params.subscribe((params: Params) => {
      this.BookingId = this._activatedRoute.snapshot.queryParams["bookingId"];

      if (this.BookingId !== undefined && this.BookingId !== null) {
        this.GetUserCompany(this.BookingId);
      }
    });
    this.GetWhiteLabelSettingVal();
    this.GetShipperConsigneeBasedOnTransportService();

    //end
  }

  GetLR() {
    if (this.hostURL == 'https://fm.ifreightbox.net/') {
      this.PrintFormatsChild.InvoiceType = 'PrintLorryReceipt4';
      this.PrintFormatsChild.From = 'Destination';
      this.PrintFormatsChild.ConsignmentNoteId = this.consignmentDetailId;
      this.PrintFormatsChild.CompId = this.CompanyId;
      this.PrintFormatsChild.PrintInvoice();
    } else if (this.hostURL == 'https://kusshal.ifreightbox.net/') {
      Helpers.setLoading(true);
      let controlarName: any = '';
      let methodName: any = '';
      let consignmentOrDetailId: any = null;
      if (this.consignmentDetailId == 'null') {
        controlarName = 'BookingOrigin';
        methodName = 'getConsignmentDetailList';
        consignmentOrDetailId = this.liveTrackData.ConsignmentNoteId;
      } else {
        controlarName = 'BookingDestination';
        methodName = 'getConsignmentDetailList';
        consignmentOrDetailId = this.consignmentDetailId;
      }
      this._appService.GetById(controlarName, methodName, consignmentOrDetailId).subscribe((response) => {
        Helpers.setLoading(false);
        this.ConsignmentsData = [];
        this.ConsignmentsData = response;

        let i = 0;
        this._appService.GetByTwoId("Booking", "GetDataForLRPrint", this.bookingId, this.CompanyId).subscribe((response) => {
          console.log(response);

          this.ConsignmentsData[0].DriverName = response[0].DriverName;
          this.ConsignmentsData[0].VehicleType = response[0].VehicleType;
          this.ConsignmentsData[0].transporterAddress = response[0].transporterAddress;
          this.ConsignmentsData[0].LicenseNo = response[0].LicenseNo;
          this.ConsignmentsData[0].TransportName = response[0].TransportName;
          this.ConsignmentsData[0].eWayBillNo = response[0].eWayBillNo;
          this.ConsignmentsData[0].eWayBillExpiryDate = response[0].eWayBillExpiryDate;
          this.ConsignmentsData[0].containerNo = response[0].containerNo;
          this.ConsignmentsData[0].DINo = response[0].DINo;
          this.ConsignmentsData[0].sealNo = response[0].sealNo;
          setTimeout(() => {
            this.ConsignmentsData.forEach(
              (element) => {
                if (
                  element.Risk == "Owner" ||
                  element.Risk == "owner" ||
                  element.Risk == "OWNER"
                ) {
                  $("#chkOwn_" + i).attr("checked", true);
                } else {
                  $("#chkTransporter_" + i).attr("checked", true);
                }

                if (
                  element.Freight == "To Pay" ||
                  element.Freight == "to pay" ||
                  element.Freight == "To pay" ||
                  element.Freight == "TO PAY" ||
                  element.Freight == "ToPay"
                ) {
                  $("#chkToPay_" + i).attr("checked", true);
                } else {
                  $("#chkToBill_" + i).attr("checked", true);
                }

                if (
                  element.GST == "Consignor" ||
                  element.GST == "consignor" ||
                  element.GST == "CONSIGNOR"
                ) {
                  $("#chkConsignor_" + i).attr("checked", true);
                } else {
                  $("#chkGSTTransporter_" + i).attr("checked", true);
                }

                if (element.Insured) {
                  $("#chkInsureYes_" + i).attr("checked", true);
                } else {
                  $("#chkInsureNo_" + i).attr("checked", true);
                }

                var TotalQty = 0;
                var TotalWeight = 0;
                var TotalValue = 0;
                var BoxPerPallet = 0;
                element.ProductDetail.forEach((element) => {
                  TotalQty = TotalQty + element.Quantity;
                  TotalWeight = TotalWeight + element.GrossWeight;
                  TotalValue = TotalValue + element.Value;
                  BoxPerPallet = BoxPerPallet + element.BoxPerPallet;
                });

                element.TotalQty = TotalQty;
                element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                element.TotalValue = TotalValue;
                element.TotalBoxPerPallet = BoxPerPallet;
                i++;
              }
            );
          }, 200);

          setTimeout(() => {
            var divElements = document.getElementById("ModalConsignmentNote_2");
            var $iframe = $("<iframe id='frame'>").appendTo("body");
            var printDiv =
              "<html><head><title> Lorry Receipt </title></head><body>" +
              divElements.innerHTML +
              "</body></html>";
            $iframe.contents().find("body").html(printDiv);
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                }, 500);
              });
            });
            $iframe.contents().find("body").html(printDiv);
          }, 1000);
        },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          });
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        });;

    }
    else {
      Helpers.setLoading(true);
      let controlarName: any = '';
      let methodName: any = '';
      let consignmentOrDetailId: any = null;
      if (this.consignmentDetailId == 'null') {
        controlarName = 'BookingOrigin';
        methodName = 'getConsignmentDetailList';
        consignmentOrDetailId = this.liveTrackData.ConsignmentNoteId;
      } else {
        controlarName = 'BookingDestination';
        methodName = 'getConsignmentDetailList';
        consignmentOrDetailId = this.consignmentDetailId;
      }
      this._appService.GetById(controlarName, methodName, consignmentOrDetailId).subscribe((response) => {
        Helpers.setLoading(false);
        this.ConsignmentsData = [];
        this.ConsignmentsData = response;

        let i = 0;
        this._appService.GetByTwoId("Booking", "GetDataForLRPrint", this.bookingId, this.CompanyId).subscribe((response) => {
          console.log(response);

          this.ConsignmentsData[0].DriverName = response[0].DriverName;
          this.ConsignmentsData[0].transporterAddress = response[0].transporterAddress;
          this.ConsignmentsData[0].LicenseNo = response[0].LicenseNo;
          this.ConsignmentsData[0].TransportName = response[0].TransportName;
          this.ConsignmentsData[0].eWayBillNo = response[0].eWayBillNo;
          this.ConsignmentsData[0].eWayBillExpiryDate = response[0].eWayBillExpiryDate;
          this.ConsignmentsData[0].containerNo = response[0].containerNo;
          this.ConsignmentsData[0].DINo = response[0].DINo;
          setTimeout(() => {
            this.ConsignmentsData.forEach(
              (element) => {
                if (
                  element.Risk == "Owner" ||
                  element.Risk == "owner" ||
                  element.Risk == "OWNER"
                ) {
                  $("#chkOwn_" + i).attr("checked", true);
                } else {
                  $("#chkTransporter_" + i).attr("checked", true);
                }

                if (
                  element.Freight == "To Pay" ||
                  element.Freight == "to pay" ||
                  element.Freight == "To pay" ||
                  element.Freight == "TO PAY" ||
                  element.Freight == "ToPay"
                ) {
                  $("#chkToPay_" + i).attr("checked", true);
                } else {
                  $("#chkToBill_" + i).attr("checked", true);
                }

                if (
                  element.GST == "Consignor" ||
                  element.GST == "consignor" ||
                  element.GST == "CONSIGNOR"
                ) {
                  $("#chkConsignor_" + i).attr("checked", true);
                } else {
                  $("#chkGSTTransporter_" + i).attr("checked", true);
                }

                if (element.Insured) {
                  $("#chkInsureYes_" + i).attr("checked", true);
                } else {
                  $("#chkInsureNo_" + i).attr("checked", true);
                }

                var TotalQty = 0;
                var TotalWeight = 0;
                var TotalValue = 0;
                var BoxPerPallet = 0;
                element.ProductDetail.forEach((element) => {
                  TotalQty = TotalQty + element.Quantity;
                  TotalWeight = TotalWeight + element.GrossWeight;
                  TotalValue = TotalValue + element.Value;
                  BoxPerPallet = BoxPerPallet + element.BoxPerPallet;
                });

                element.TotalQty = TotalQty;
                element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                element.TotalValue = TotalValue;
                element.TotalBoxPerPallet = BoxPerPallet;
                i++;
              }
            );
          }, 200);

          setTimeout(() => {
            var divElements = document.getElementById("ModalConsignmentNote_3");
            var $iframe = $("<iframe id='frame'>").appendTo("body");
            var printDiv =
              "<html><head><title> Lorry Receipt </title></head><body>" +
              divElements.innerHTML +
              "</body></html>";
            $iframe.contents().find("body").html(printDiv);
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                }, 500);
              });
            });
            $iframe.contents().find("body").html(printDiv);
          }, 1000);
        },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          });
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        });;
    }
  }

  openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  GetLiveTrackListForBooking() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("Booking", "GetLiveTrackListForBooking", this.bookingId, this.consignmentDetailId).subscribe((response) => {
      Helpers.setLoading(false);
      this.liveTrackData = response.Table[0];
      this.liveTrackData.documentList = [];
      this.liveTrackData.documentList = (response.Table1);
      this.liveTrackData.orderDetailsList = [];
      this.liveTrackData.orderDetailsList.push(response.Table2[0]);
      this.liveTrackData.documentList.forEach(element => {
        if (element.documentFileName !== null) {
          element.documentFileName = element.documentFileName.split(/_(.+)/)[1] + '.' + element.documentFileExtension;
        }
      });
      this.initMap();
      console.log('this.liveTrackData.documentList', this.liveTrackData.documentList);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  VehicleDirectionDegree: any = 0;
  svg: any = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

  initMap() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    this.map = new google.maps.Map(document.getElementById("directionMap"), {
      zoom: 6,
      center: { lat: 41.85, lng: -87.65 },
    });
    const image = "../../assets/img/truck_inactive.png";
    const infoWindow = new google.maps.InfoWindow();
    if (this.hostURL != 'https://ncc.ifreightbox.net/') {
      this.beachMarker = new google.maps.Marker({
        position: { lat: this.liveTrackData.driverLocationLAT, lng: this.liveTrackData.driverLocationLNG },
        map: this.map,
        // icon: image,
        icon: {
          anchor: new google.maps.Point(16, 16),
          url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(this.svg),
          scale: 3,
          fillColor: "red",
          fillOpacity: 0.8,
          strokeWeight: 2,
          rotation: this.VehicleDirectionDegree //this is how to rotate the pointer
        },
        title: this.liveTrackData.vehicleNo,
      });
      this.beachMarker.addListener("click", () => {
        this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          this.beachMarker.setAnimation(null);
        }, 2000);
        infoWindow.close();
        infoWindow.setContent('<table style="table-layout: fixed;">' +
          '<tr>' +
          '<td style="font-weight: bold">Vehicle No:</td>' +
          '<td>' + this.liveTrackData.vehicleNo + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Driver:</td>' +
          '<td>' + this.liveTrackData.driverName + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Driver Mobile No:</td>' +
          '<td>' + this.liveTrackData.driverMobileNo + '</td>' +
          '</tr>' +
          //added by vithujan 12-09-2022
          '<tr>' +
          '<td style="font-weight: bold">Last Tracked:</td>' +
          '<td>' + this.liveTrackData.LastTracked + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Speed:</td>' +
          '<td>' + this.liveTrackData.Speed + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Status:</td>' +
          '<td><b>' + this.liveTrackData.TrackStatus + '</b></td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Track By:</td>' +
          '<td><b>' + this.liveTrackData.TrackThrough + '</b></td>' +
          '</tr>' +
          //end
          '</table>');
        infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
      });
    }
    // google.maps.event.addListener(this.map, 'click', (event) => {
    //   var result = [event.latLng.lat(), event.latLng.lng()];
    //   this.transition(result);
    // });

    directionsRenderer.setMap(this.map);
    //added by maaria on 28-10-2023
    if (this.yardAddress == '' || this.yardAddress == null) {
      this.calculateAndDisplayRoute(directionsService, directionsRenderer);
    }
    else {
      this.calculateAndDisplayRouteWithPickup(directionsService, directionsRenderer);
    }
    //end

    //this.calculateAndDisplayRoute(directionsService, directionsRenderer); //works
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    directionsService
      .route({
        origin: {
          query: this.liveTrackData.originAddress,
        },
        destination: {
          query: this.liveTrackData.destinationAddress,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);

        var route = response.routes[0];
        var bounds = new google.maps.LatLngBounds();
        route.legs.forEach(function (leg) {
          bounds.extend(leg.start_location);
          bounds.extend(leg.end_location);
        });

        // Calculate the center of the route
        var center = bounds.getCenter();

        // Draw a circle with a radius of 50km around the origin
        var originCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          map: this.map,
          center: route.legs[0].start_location,
          radius: this.liveTrackData.MapRadious * 1000 // km in meters
        });

        // Draw a circle with a radius of 50km around the destination
        var destinationCircle = new google.maps.Circle({
          strokeColor: '#00FF00',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#00FF00',
          fillOpacity: 0.35,
          map: this.map,
          center: route.legs[route.legs.length - 1].end_location,
          radius: this.liveTrackData.MapRadious * 1000 // km in meters
        });

        // Optionally, display the radius value on the map
        var originInfowindow = new google.maps.InfoWindow({
          content: "Origin Radius: 50km"
        });

        var destinationInfowindow = new google.maps.InfoWindow({
          content: "Destination Radius: 50km"
        });

        originInfowindow.open(this.map, originCircle);
        destinationInfowindow.open(this.map, destinationCircle);

      })
      .catch((e) => window.alert("Directions request failed due to " + status));
  }
  //added by maaria on 28-10-2023
  calculateAndDisplayRouteWithPickup(directionsService, directionsRenderer) {
    directionsService
      .route({
        origin: {
          query: this.yardAddress,
        },
        waypoints: [{ location: this.liveTrackData.originAddress, stopover: true }],
        destination: {
          query: this.liveTrackData.destinationAddress,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
      })
      .catch((e) => window.alert("Directions request failed due to " + status));
  }
  //end

  GetLiveTrackListForBookingFromURL() {
    Helpers.setLoading(true);
    this.getByTwoIdLiveTrack(this.bookingId, this.consignmentDetailId).subscribe((data) => {
      this.yardAddress = '';
      this.liveTrackData = data.Table[0];
      this.liveTrackData.Speed = 0;

      setInterval(function () {
        LiveTrackingComponent.liveTrackingComponent.lr_getTripStageStausData();
      }, 15000);

      this.liveTrackData.documentList = [];
      this.liveTrackData.documentList = (data.Table1);
      this.liveTrackData.orderDetailsList = [];
      this.liveTrackData.orderDetailsList = data.Table2;
      //add by maaria on 28-10-2023
      this.liveTrackData.orderDetailsList.forEach(item => {
        if (item.containerPickupYardId != "" || item.containerPickupYardId != null) {
          this.yardAddress = item.YardAddress;
        }
      });
      //end
      this.rate = this.liveTrackData.orderDetailsList[0].starRating;
      this.feedbackRemark = this.liveTrackData.orderDetailsList[0].feedbackRemark;
      this.liveTrackData.documentList.forEach(element => {
        if (element.documentFileName !== null) {
          element.documentFileName = element.documentFileName.split(/_(.+)/)[1] + '.' + element.documentFileExtension;
        }
      });

      if (this.liveTrackData.GPSTrackingUrl != null && (this.liveTrackData.isSIMTracking != 'YES' || this.liveTrackData.TrackingTripId == null)) {
        if (this.apiUrl == 'https://jal.ifreightbox.net/') {
          this._appService.GetById("Booking", "GetLatLngByVehicleNo", this.liveTrackData.vehicleNo).subscribe((data) => {
            try {
              JSON.parse(data);
              var formtaedResponse = JSON.parse(data);
              var response = formtaedResponse.root.detaildata;
              if (response[0].lattitude != undefined) {
                this.liveTrackData.driverLocationLAT = parseFloat(response[0].lattitude);
                this.liveTrackData.driverLocationLNG = parseFloat(response[0].longitude);

                this.liveTrackData.TrackThrough = 'GPS';
                this.isGPS = true;
              }
            } catch (e) { }
            this.initMap();
          },
            (error) => {
              this.toastr.error(error._body.replace(/"/g, ""), "Error");
              Helpers.setLoading(false);
            });
        } else {
          if (this.apiUrl != 'https://tt.ifreightbox.net/') {
            this._appService.GetByTwoId("OrdersByVehicle", "opa_getTripLiveData_GPSWise_fromTable", this.liveTrackData.vehicleNo, this.bookingId).subscribe((data) => {
              try {
                var response1_obj: any = [];
                response1_obj = data;
                if (response1_obj.length > 0) {
                  this.isGPS = true;
                  this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
                  this.liveTrackData.driverLocationLAT = parseFloat(response1_obj[0].Latitude);
                  this.liveTrackData.driverLocationLNG = parseFloat(response1_obj[0].Longitude);
                }
              } catch (e) { }
              this.initMap();
            },
              (error) => {
                this.toastr.error(error._body.replace(/"/g, ""), "Error");
                Helpers.setLoading(false);
              });
          } else {
            this._appService.GetById('Booking', 'lt_getGPSSingleVehicleData', this.liveTrackData.vehicleNo).subscribe((data) => {
              data = JSON.parse(data);
              if (data.root.VehicleData != undefined) {
                this.isGPS = true;
                this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
                this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
                this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);
              }
              this.initMap();
            },
              (error) => {
                this.toastr.error(error, "Error");
                Helpers.setLoading(false);
              });
          }

          // this.getGPSLiveTrackLocation(this.liveTrackData.GPSTrackingUrl).subscribe((data) => {
          //   if (data.root.VehicleData != undefined) {
          //     this.isGPS = true;
          //     this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
          //     this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
          //     this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);
          //   }
          //   this.initMap();
          // },
          //   (error) => {
          //     this.toastr.error(error, "Error");
          //     Helpers.setLoading(false);
          //   });
        }
      }
      else if (this.liveTrackData.isSIMTracking == 'YES') {
        this._appService.GetById("Booking", "trck_GetSimTrackData", this.liveTrackData.TrackingTripId).subscribe((response) => {
          var resObjS: any = [];
          resObjS = response;
          if (resObjS.length > 0) {
            this.liveTrackData.driverLocationLAT = parseFloat(response[0].latitude);
            this.liveTrackData.driverLocationLNG = parseFloat(response[0].longitude);
          }
          this.initMap();
        },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error")
          }
        )
        
        // var settings = {
        //   "async": true,
        //   "crossDomain": true,
        //   "url": "https://sct.intutrack.com/api/test/status?tripId=" + this.liveTrackData.TrackingTripId,
        //   "method": "GET",
        //   "headers": {
        //     "authorization": "Basic c0dGMHBqMnRvcG01SzdUa05KUUhIZWxCRXQyOHROVGEzbktNVU40ajNTSUk3VVowM0hGS21ReHlXUWtiOWhQMjo1eVA4UEFhSXROUDRsNFIwNkJNRDBQQ1FpbFdlNkM2bmhlRmNjbDhGWlRIeURqWGRZRllncEQybU54OHBVTzlx",
        //     "content-type": "application/x-www-form-urlencoded",
        //     "cache-control": "no-cache",
        //     "username": "sGF0pj2topm5K7TkNJQHHelBEt28tNTa3nKMUN4j3SII7UZ03HFKmQxyWQkb9hP2",
        //     "password": "5yP8PAaItNP4l4R06BMD0PCQilWe6C6nheFccl8FZTHyDjXdYFYgpD2mNx8pUO9q"
        //   }
        // }
        // $.ajax(settings).done(function (response) {
        //   var resObjS: any = [];
        //   resObjS = response;
        //   if (resObjS.length > 0) {
        //     LiveTrackingComponent.liveTrackingComponent.liveTrackData.driverLocationLAT = parseFloat(response[0].loc[0]);
        //     LiveTrackingComponent.liveTrackingComponent.liveTrackData.driverLocationLNG = parseFloat(response[0].loc[1]);
        //   }
        //   LiveTrackingComponent.liveTrackingComponent.initMap();
        // })
        //   .fail(function (jqXHR) {
        //     console.log('errorThrown', jqXHR.responseText);
        //     LiveTrackingComponent.liveTrackingComponent.initMap();
        //   });
      }
      else {
        this.initMap();
      }
      console.log('this.liveTrackData', this.liveTrackData);
      Helpers.setLoading(false);
    },
      (error) => {
        this.toastr.error(error._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  getByTwoIdLiveTrack(id: any, param1: any) {
    return this.http.get(environment.apiUrl + 'api/Booking/GetLiveTrackListForBooking/?id=' + id + '&param1=' + param1).map((response: Response) => response.json());
  }

  getGPSLiveTrackLocation(URL: any) {
    return this.http.get(URL).map((response: Response) => response.json());
  }

  starRatingSave() {
    Helpers.setLoading(true);
    this._appService.GetByFourId("OrdersByVehicle", "obv_starRatingSave", this.bookingId, this.consignmentDetailId, this.rate, this.feedbackRemark).subscribe((response) => {
      Helpers.setLoading(false);
      this.liveTrackData.orderDetailsList.forEach(element => {
        element.starRating = this.rate;
        element.feedbackRemark = this.feedbackRemark;
      });
      this.toastr.success("Order Cancelled Successfully ", "Success");
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  getProductList() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("Booking", "LT_getProductList", this.bookingId, this.consignmentDetailId).subscribe((response) => {
      Helpers.setLoading(false);
      $(".productListModel").modal("show");
      this.ProductData = response;
      let i = 0;
      this.ProductData.forEach(function (value, prop, obj) {
        if (i == 0) {
          LiveTrackingComponent.liveTrackingComponent.ProductHeader = Object.getOwnPropertyNames(value);
        }
        i++;
      });
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  getDriverCurrentLatLong() {
    this._appService.GetByTwoId("Booking", "LT_getDriverCurrentLatLong", this.bookingId, this.consignmentDetailId).subscribe((response) => {
      var objOldLatLong: any = [this.liveTrackData.driverLocationLAT, this.liveTrackData.driverLocationLNG];
      if (this.liveTrackData.driverLocationLAT == null || this.liveTrackData.driverLocationLNG == null) {
        objOldLatLong = [response[0].driverLocationLAT, response[0].driverLocationLNG];
      }
      var newOldLatLong: any = [response[0].driverLocationLAT, response[0].driverLocationLNG];
      if (this.liveTrackData.driverLocationLAT != newOldLatLong[0] && this.liveTrackData.driverLocationLNG != newOldLatLong[1]) {
        this.transition(newOldLatLong, objOldLatLong);
      }
      this.liveTrackData.driverLocationLAT = response[0].driverLocationLAT;
      this.liveTrackData.driverLocationLNG = response[0].driverLocationLNG;
      //added by vithujan 13-09-2022
      this.liveTrackData.LastTracked = response[0].LastTracked;
      this.liveTrackData.TrackStatus = response[0].TrackStatus;
      this.liveTrackData.TrackThrough = response[0].TrackThrough;
      this.liveTrackData.Speed = response[0].Speed;
      var image = "../../assets/img/truck_inactive.png";
      if (this.liveTrackData.TrackStatus == 'Active') {
        image = "../../assets/img/truck_active.png";
      } else {
        image = "../../assets/img/truck_inactive.png";
      }
      //end

      // this.beachMarker.setMap(null);
      // const infoWindow = new google.maps.InfoWindow();
      // this.beachMarker = new google.maps.Marker({
      //   position: { lat: this.liveTrackData.driverLocationLAT, lng: this.liveTrackData.driverLocationLNG },
      //   map: this.map,
      //   icon: image,
      //   title: this.liveTrackData.vehicleNo,
      // });
      // this.beachMarker.addListener("click", () => {
      //   this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
      //   setTimeout(() => {
      //     this.beachMarker.setAnimation(null);
      //   }, 2000);
      //   infoWindow.close();
      //   infoWindow.setContent('<table style="table-layout: fixed;">' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Vehicle No:</td>' +
      //     '<td>' + this.liveTrackData.vehicleNo + '</td>' +
      //     '</tr>' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Driver:</td>' +
      //     '<td>' + this.liveTrackData.driverName + '</td>' +
      //     '</tr>' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Driver Mobile No:</td>' +
      //     '<td>' + this.liveTrackData.driverMobileNo + '</td>' +
      //     '</tr>' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Last Tracked:</td>' +
      //     '<td>' + this.liveTrackData.LastTracked + '</td>' +
      //     '</tr>' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Status:</td>' +
      //     '<td><b>' + this.liveTrackData.TrackStatus + '</b></td>' +
      //     '</tr>' +
      //     '<tr>' +
      //     '<td style="font-weight: bold">Status:</td>' +
      //     '<td><b>' + this.liveTrackData.TrackThrough + '</b></td>' +
      //     '</tr>' +
      //     '</table>');
      //   infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
      //   this.beachMarker.setMap(this.map);
      // });
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  getDriverCurrentLatLong_GPS() {
    // this.beachMarker.forEach((element, index) => {
    //   this.beachMarker[index].setMap(null);
    // });
    // this.beachMarker.setMap(null);
    if (this.apiUrl == 'https://jal.ifreightbox.net/') {
      this._appService.GetById("Booking", "GetLatLngByVehicleNo", this.liveTrackData.vehicleNo).subscribe((data) => {
        try {
          JSON.parse(data);
          var formtaedResponse = JSON.parse(data);
          var response = formtaedResponse.root.detaildata;
          if (response[0].lattitude != undefined) {
            var objOldLatLong: any = [this.liveTrackData.driverLocationLAT, this.liveTrackData.driverLocationLNG];
            var newOldLatLong: any = [response[0].Latitude, response[0].Longitude];
            if (this.liveTrackData.driverLocationLAT != newOldLatLong[0] && this.liveTrackData.driverLocationLNG != newOldLatLong[1]) {
              this.transition(newOldLatLong, objOldLatLong);
            }

            this.liveTrackData.driverLocationLAT = parseFloat(response[0].lattitude);
            this.liveTrackData.driverLocationLNG = parseFloat(response[0].longitude);
            //added by vithujan 13-09-2022
            this.liveTrackData.LastTracked = response[0].GPSActualTime;

            var today = new Date();
            var gpsDate = new Date(response[0].GPSActualTime);
            var diff = today.getTime() - gpsDate.getTime();
            var days = Math.floor(diff / (60 * 60 * 24 * 1000));
            var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
            var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));


            var image = "../../assets/img/truck_inactive.png";

            if (minutes > 1) {
              this.liveTrackData.TrackStatus = 'InActive';
              image = "../../assets/img/truck_inactive.png";
            } else {
              this.liveTrackData.TrackStatus = 'Active';
              image = "../../assets/img/truck_active.png";
            }
            this.liveTrackData.TrackThrough = 'GPS';
            //end

            // const infoWindow = new google.maps.InfoWindow();
            // this.beachMarker = new google.maps.Marker({
            //   position: { lat: this.liveTrackData.driverLocationLAT, lng: this.liveTrackData.driverLocationLNG },
            //   map: this.map,
            //   icon: image,
            //   title: this.liveTrackData.vehicleNo,
            // });
            // this.beachMarker.addListener("click", () => {
            //   this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
            //   setTimeout(() => {
            //     this.beachMarker.setAnimation(null);
            //   }, 2000);
            //   // infoWindow.close();
            //   infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
            //   this.beachMarker.setMap(this.map);
            //   // this.beachMarker.push(bmMarker);
            // });
          }
        } catch (e) { }
      },
        (error) => {
          this.toastr.error(error._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        });
    } else {
      if (this.apiUrl != 'https://tt.ifreightbox.net/') {
        this._appService.GetByTwoId("OrdersByVehicle", "opa_getTripLiveData_GPSWise_fromTable", this.liveTrackData.vehicleNo, this.bookingId).subscribe((data) => {
          try {
            var response1_obj: any = [];
            response1_obj = data;
            if (response1_obj.length > 0) {
              this.isGPS = true;
              this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
              this.liveTrackData.Speed = response1_obj[0].Speed;


              var objOldLatLong: any = [this.liveTrackData.driverLocationLAT, this.liveTrackData.driverLocationLNG];
              var newOldLatLong: any = [response1_obj[0].Latitude, response1_obj[0].Longitude];
              if (this.liveTrackData.driverLocationLAT != newOldLatLong[0] && this.liveTrackData.driverLocationLNG != newOldLatLong[1]) {
                this.transition(newOldLatLong, objOldLatLong);
              }

              this.liveTrackData.driverLocationLAT = parseFloat(response1_obj[0].Latitude);
              this.liveTrackData.driverLocationLNG = parseFloat(response1_obj[0].Longitude);

              this.liveTrackData.LastTracked = response1_obj[0].GPSActualTime;

              var today = new Date();
              var gpsDate = new Date(response1_obj[0].GPSActualTime);
              var diff = today.getTime() - gpsDate.getTime();
              var days = Math.floor(diff / (60 * 60 * 24 * 1000));
              var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
              var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));


              var image = "../../assets/img/truck_inactive.png";

              if (minutes > 1) {
                this.liveTrackData.TrackStatus = 'InActive';
                image = "../../assets/img/truck_inactive.png";
              } else {
                this.liveTrackData.TrackStatus = 'Active';
                image = "../../assets/img/truck_active.png";
              }
              this.liveTrackData.TrackThrough = 'GPS';
              //end

              // const infoWindow = new google.maps.InfoWindow();
              // this.beachMarker = new google.maps.Marker({
              //   position: { lat: this.liveTrackData.driverLocationLAT, lng: this.liveTrackData.driverLocationLNG },
              //   map: this.map,
              //   icon: image,
              //   title: this.liveTrackData.vehicleNo,
              // });
              // this.beachMarker.addListener("click", () => {
              //   this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
              //   setTimeout(() => {
              //     this.beachMarker.setAnimation(null);
              //   }, 2000);
              //   infoWindow.close();
              //   infoWindow.setContent('<table style="table-layout: fixed;">' +
              //     '<tr>' +
              //     '<td style="font-weight: bold">Vehicle No:</td>' +
              //     '<td>' + this.liveTrackData.vehicleNo + '</td>' +
              //     '</tr>' +
              //     '<tr>' +
              //     '<td style="font-weight: bold">Driver:</td>' +
              //     '<td>' + this.liveTrackData.driverName + '</td>' +
              //     '</tr>' +
              //     '<tr>' +
              //     '<td style="font-weight: bold">Driver Mobile No:</td>' +
              //     '<td>' + this.liveTrackData.driverMobileNo + '</td>' +
              //     '</tr>' +
              //     //added by vithujan 12-09-2022
              //     '<tr>' +
              //     '<td style="font-weight: bold">Last Tracked:</td>' +
              //     '<td>' + this.liveTrackData.LastTracked + '</td>' +
              //     '</tr>' +
              //     '<tr>' +
              //     '<td style="font-weight: bold">Status:</td>' +
              //     '<td><b>' + this.liveTrackData.TrackStatus + '</b></td>' +
              //     '</tr>' +
              //     '<tr>' +
              //     '<td style="font-weight: bold">Status:</td>' +
              //     '<td><b>' + this.liveTrackData.TrackThrough + '</b></td>' +
              //     '</tr>' +
              //     //end
              //     '</table>');
              //   infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
              //   this.beachMarker.setMap(this.map);
              //   // this.beachMarker.push(bmMarker);
              // });
            }
          } catch (e) { }
          // this.initMap();
        },
          (error) => {
            this.toastr.error(error._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          });
      } else {
        this._appService.GetById('Booking', 'lt_getGPSSingleVehicleData', this.liveTrackData.vehicleNo).subscribe((data) => {
          data = JSON.parse(data);
          if (data.root.VehicleData != undefined) {
            console.log('data', data);
            var singleVehicle = data.root.VehicleData[0];
            // this.isGPS = true;
            // this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
            // this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
            // this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);

            this.isGPS = true;
            this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
            this.liveTrackData.Speed = singleVehicle.Speed;


            var objOldLatLong: any = [this.liveTrackData.driverLocationLAT, this.liveTrackData.driverLocationLNG];
            var newOldLatLong: any = [singleVehicle.Latitude, singleVehicle.Longitude];
            if (this.liveTrackData.driverLocationLAT != newOldLatLong[0] && this.liveTrackData.driverLocationLNG != newOldLatLong[1]) {
              this.transition(newOldLatLong, objOldLatLong);
            }

            this.liveTrackData.driverLocationLAT = parseFloat(singleVehicle.Latitude);
            this.liveTrackData.driverLocationLNG = parseFloat(singleVehicle.Longitude);
            this.liveTrackData.LastTracked = singleVehicle.GPSActualTime;

            var today = new Date();
            var gpsDate = new Date(singleVehicle.GPSActualTime);
            var diff = today.getTime() - gpsDate.getTime();
            var days = Math.floor(diff / (60 * 60 * 24 * 1000));
            var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
            var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));


            var image = "../../assets/img/truck_inactive.png";

            if (minutes > 1) {
              this.liveTrackData.TrackStatus = 'InActive';
              image = "../../assets/img/truck_inactive.png";
            } else {
              this.liveTrackData.TrackStatus = 'Active';
              image = "../../assets/img/truck_active.png";
            }
            this.liveTrackData.TrackThrough = 'GPS';
          }
          this.initMap();
        },
          (error) => {
            this.toastr.error(error, "Error");
            Helpers.setLoading(false);
          });
      }
    }
  }

  position: any = [40.748774, -73.985763];
  numDeltas: any = 60000;
  delay: any = 600; //milliseconds
  i: any = 0;
  deltaLat: any;
  deltaLng: any;
  transition(result, position) {
    this.position = position;
    this.i = 0;
    this.deltaLat = (result[0] - this.position[0]) / this.numDeltas;
    this.deltaLng = (result[1] - this.position[1]) / this.numDeltas;
    this.CalculateDegrees(position[0], position[1], result[0], result[1]);
    this.moveMarker();
  }

  moveMarker() {
    this.position[0] = parseFloat(this.position[0] + this.deltaLat);
    this.position[1] = parseFloat(this.position[1] + this.deltaLng);
    var latlng = new google.maps.LatLng(this.position[0], this.position[1]);

    // this.beachMarker.setTitle("Latitude:" + position[0] + " | Longitude:" + position[1]);
    if (this.hostURL != 'https://ncc.ifreightbox.net/') {
      this.beachMarker.setPosition(latlng);
    }
    if (this.i != this.numDeltas) {
      this.i = this.i + 1;
      setTimeout(() => {
        this.moveMarker();
      }, this.delay);
    }
  }

  CalculateDegrees(start_latitude: any, start_longitude: any, stop_latitude: any, stop_longitude: any) {
    console.log('coordinates', "[", start_latitude, "]", "[", start_longitude, "]", "[", stop_latitude, "]", "[", stop_longitude, "]");
    //Source
    var lat1 = parseFloat(start_latitude);
    var lng1 = parseFloat(start_longitude);

    // destination
    var lat2 = parseFloat(stop_latitude);
    var lng2 = parseFloat(stop_longitude);

    var fLat = this.degreeToRadians(lat1);
    var fLong = this.degreeToRadians(lng1);
    var tLat = this.degreeToRadians(lat2);
    var tLong = this.degreeToRadians(lng2);

    var dLon = (tLong - fLong);

    var degree = this.radiansToDegree(Math.atan2(Math.sin(dLon) * Math.cos(tLat),
      Math.cos(fLat) * Math.sin(tLat) - Math.sin(fLat) * Math.cos(tLat) * Math.cos(dLon)));

    if (degree >= 0) {
      this.VehicleDirectionDegree = degree;
    } else {
      this.VehicleDirectionDegree = 360 + degree;
    }

    this.svg = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

    var icon = {
      anchor: new google.maps.Point(16, 16),
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(this.svg),
      scale: 3,
      fillColor: "red",
      fillOpacity: 0.8,
      strokeWeight: 2,
      rotation: this.VehicleDirectionDegree //this is how to rotate the pointer
    };
    if (this.hostURL != 'https://ncc.ifreightbox.net/') {
      this.beachMarker.setIcon(icon);
    }
  }

  degreeToRadians(latLong) {
    return (Math.PI * latLong / 180.0);
  }

  radiansToDegree(latLong) {
    return (latLong * 180.0 / Math.PI);
  }

  //add vithujan 18-07-2022
  GetUserCompany(id: string) {
    this._appService
      .GetById("Company", "GetUserCompanyData", id)
      .subscribe(
        (response) => {
          this.TenantUsers = response.data; //FOR DROPDOWN

          this.TenantUsers.forEach((element) => {
            if (element.DefaultCompanyId == element.Id) {
              this.CompanyIdForCookie = element;

              this.CompanyId = this.CompanyIdForCookie.Id;
              this.SelectedComapnyName = this.CompanyIdForCookie.SelectedComapnyName;
              this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
              this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
              this.SelectedCompantGSTIN = this.CompanyIdForCookie.SelectedCompantGSTIN;
              this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
              this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
              this.SelectedCompantEmail = this.CompanyIdForCookie.SelectedComapnyEmail;
              this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
              this.SelectedCompanyHeadAdd = this.CompanyIdForCookie.SelectedCompanyHeadAdd;
              this.CompanyWebsite = this.CompanyIdForCookie.CompanyWebsite;
              //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
              this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
            }
          });
        },
        (err) => {
          console.log(err);
          console.log("Error occured");
        }
      );
  }
  //end

  GetWhiteLabelSettingVal() {
    this._appService.GetById("Common", "GetSystemSettingByName", "WhiteLabel").subscribe((response) => {
      if (response == "1") {
        this.whitelabelFlag = true;
      } else {
        this.whitelabelFlag = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  GetLiveTrackingThrowWarehouseLatLongSettingVal() {
    this._appService.GetById("Common", "GetSystemSettingByName", "LiveTrackingThrowWarehouseLatLong").subscribe((response) => {
      if (response == "1") {
        this.LiveTrackingThrowWarehouseLatLongFlage = true;
      } else {
        this.LiveTrackingThrowWarehouseLatLongFlage = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });

    this._appService.GetById("Common", "GetSystemSettingByName", "HideShow").subscribe((response) => {
      if (response == "1") {
        this.HideShowOrderRistInsuarnceGSTFreightFlag = true;
      } else {
        this.HideShowOrderRistInsuarnceGSTFreightFlag = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  lr_getTripStageStausData() {
    this._appService.GetByTwoId("Booking", "lr_getTripStageStausData", this.bookingId, this.consignmentDetailId).subscribe((response) => {
      var resObj: any = [];
      resObj = response;
      if (resObj.length > 0) {
        this.liveTrackData.bookingDate = resObj[0].bookingDate;
        this.liveTrackData.vehicleAssignedDate = resObj[0].vehicleAssignedDate;
        this.liveTrackData.gateInTime = resObj[0].gateInTime;
        this.liveTrackData.OriginArrivalTime = resObj[0].OriginArrivalTime;
        this.liveTrackData.readyToDispatch = resObj[0].readyToDispatch;
        this.liveTrackData.dispachedDate = resObj[0].dispachedDate;
        this.liveTrackData.eWayBillReady = resObj[0].eWayBillReady;
        this.liveTrackData.gateOutTime = resObj[0].gateOutTime;
        this.liveTrackData.destinationGateIn = resObj[0].destinationGateIn;
        this.liveTrackData.DestinationArrrivalTime = resObj[0].DestinationArrrivalTime;
        this.liveTrackData.destinationGateOut = resObj[0].destinationGateOut;
        this.liveTrackData.confirmDelivery = resObj[0].confirmDelivery;
        this.liveTrackData.completed = resObj[0].completed;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  GetShipperConsigneeBasedOnTransportService() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "ShipperConsigneeBasedOnTransportService")
      .subscribe(
        (response) => {
          if (response == '1') {
            this.ShowShipperConsigneeBasedOnTransportService = true;
          } else {
            this.ShowShipperConsigneeBasedOnTransportService = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

}

